import { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

// Compact market status + live countdown, shown globally under the logo (every page).
export default function MarketClock() {
  const { data: clock } = useQuery({ queryKey: ['market-clock'], queryFn: () => api.trading.clock('paper'), retry: false, refetchInterval: 60_000 })
  const [nowTs, setNowTs] = useState(Date.now())
  useEffect(() => { const t = setInterval(() => setNowTs(Date.now()), 1000); return () => clearInterval(t) }, [])
  if (!clock) return null
  const open = !!clock.is_open
  const targetIso = open ? clock.next_close : clock.next_open
  let cd = '—'
  if (targetIso) {
    const ms = new Date(targetIso).getTime() - nowTs
    if (ms > 0) {
      const h = Math.floor(ms / 3_600_000), m = Math.floor((ms % 3_600_000) / 60_000), s = Math.floor((ms % 60_000) / 1000)
      cd = h > 0 ? `${h}h ${m}m ${s}s` : `${m}m ${s}s`
    }
  }
  return (
    <div style={{ fontFamily: 'Syne Mono', fontSize: '0.52rem', letterSpacing: '0.04em', marginTop: 4, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <span style={{ color: open ? 'var(--cash)' : 'var(--muted)' }}>● {open ? 'OPEN' : 'CLOSED'}</span>
      <span style={{ color: 'var(--muted)' }}>{open ? `${cd} to close` : `opens in ${cd}`}</span>
    </div>
  )
}
